import { render, staticRenderFns } from "./detail.html?vue&type=template&id=47787774&scoped=true&external"
import script from "./detail.js?vue&type=script&lang=js&external"
export * from "./detail.js?vue&type=script&lang=js&external"
import style0 from "./detail.scss?vue&type=style&index=0&id=47787774&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47787774",
  null
  
)

export default component.exports